export default "__VITE_ASSET__DgHnxxD0__"